import { defineMessages, type IntlShape } from 'react-intl'

export const channelTemplateMessages = defineMessages({
  qualityHigh: {
    defaultMessage: 'High',
    description: 'WhatsApp template quality rating',
  },
  qualityLow: {
    defaultMessage: 'Low',
    description: 'WhatsApp template quality rating',
  },
  qualityMedium: {
    defaultMessage: 'Medium',
    description: 'WhatsApp template quality rating',
  },
  qualityUnknown: {
    defaultMessage: 'Unknown',
    description: 'WhatsApp template quality rating',
  },
  statusApproved: {
    defaultMessage: 'Approved',
    description: 'WhatsApp template status',
  },
  statusDisabled: {
    defaultMessage: 'Disabled',
    description: 'WhatsApp template status',
  },
  statusInAppeal: {
    defaultMessage: 'In appeal',
    description: 'WhatsApp template status',
  },
  statusPaused: {
    defaultMessage: 'Paused',
    description: 'WhatsApp template status',
  },
  statusPending: {
    defaultMessage: 'Pending',
    description: 'WhatsApp template status',
  },
  statusRejected: {
    defaultMessage: 'Rejected',
    description: 'WhatsApp template status',
  },
})

/**
 * Label for a raw Meta template status (`MessagingChannelTemplate.status` is
 * a plain string mirrored from Business Manager, not a contract enum).
 * Unknown values fall back to the raw string.
 */
export function translateTemplateStatus(intl: IntlShape, status: string): string {
  switch (status.toUpperCase()) {
    case 'APPROVED':
      return intl.formatMessage(channelTemplateMessages.statusApproved)
    case 'PENDING':
      return intl.formatMessage(channelTemplateMessages.statusPending)
    case 'REJECTED':
      return intl.formatMessage(channelTemplateMessages.statusRejected)
    case 'PAUSED':
      return intl.formatMessage(channelTemplateMessages.statusPaused)
    case 'DISABLED':
      return intl.formatMessage(channelTemplateMessages.statusDisabled)
    case 'IN_APPEAL':
      return intl.formatMessage(channelTemplateMessages.statusInAppeal)
    default:
      return status
  }
}

/**
 * Label for a raw Meta quality rating (GREEN/YELLOW/RED or HIGH/MEDIUM/LOW).
 *
 * Meta uses ONE quality vocabulary in two spellings: the template catalog
 * reports HIGH/MEDIUM/LOW, a phone number's health reports GREEN/YELLOW/RED.
 * They mean the same three grades, so this is deliberately not
 * template-specific — the number-health chip translates through it too, and
 * shows the raw Meta value beside the label so the spelling stays visible.
 */
export function translateWhatsAppQuality(intl: IntlShape, quality: string | null): string {
  switch (quality?.toUpperCase()) {
    case 'GREEN':
    case 'HIGH':
      return intl.formatMessage(channelTemplateMessages.qualityHigh)
    case 'YELLOW':
    case 'MEDIUM':
      return intl.formatMessage(channelTemplateMessages.qualityMedium)
    case 'RED':
    case 'LOW':
      return intl.formatMessage(channelTemplateMessages.qualityLow)
    default:
      return intl.formatMessage(channelTemplateMessages.qualityUnknown)
  }
}
